var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _rect122, _rect123, _rect124, _rect125, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _rect154, _rect155, _rect156, _rect157, _rect158, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _rect179, _rect180, _rect181, _rect182, _rect183, _rect184, _rect185, _rect186, _rect187, _rect188, _rect189, _rect190, _rect191, _rect192, _rect193, _rect194, _rect195, _rect196, _rect197, _rect198, _rect199, _rect200, _rect201, _rect202, _rect203, _rect204, _rect205, _rect206, _rect207, _rect208, _rect209, _rect210, _rect211, _rect212, _rect213, _rect214, _rect215, _rect216, _rect217, _rect218, _rect219, _rect220, _rect221, _rect222, _rect223, _rect224, _rect225, _rect226, _rect227, _rect228, _rect229, _rect230, _rect231, _rect232, _rect233, _rect234, _rect235, _rect236, _rect237, _rect238, _rect239, _rect240, _rect241, _rect242, _rect243, _rect244, _rect245, _rect246, _rect247, _rect248, _rect249, _rect250, _rect251, _rect252, _rect253, _rect254, _rect255, _rect256, _rect257, _rect258, _rect259, _rect260, _rect261, _rect262, _rect263, _rect264, _rect265, _rect266, _rect267, _rect268, _rect269, _rect270, _rect271, _rect272, _rect273, _rect274, _rect275, _rect276, _rect277, _rect278, _rect279, _rect280, _rect281, _rect282, _rect283, _rect284, _rect285, _rect286, _rect287, _rect288, _rect289, _rect290, _rect291, _rect292, _rect293, _rect294, _rect295, _rect296, _rect297, _rect298, _rect299, _rect300, _rect301, _rect302, _rect303;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPixelArtDog(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 741,
    height: 314,
    viewBox: "0 0 741 314",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 44.1562,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2856,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8569,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2856,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8569,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4287,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4287,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 291.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7144,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 111.442,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 133.871,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 156.299,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7144,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 66.5847,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 111.442,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 133.871,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 156.299,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 178.728,
    width: 22.4286,
    height: 22.4286,
    fill: "#8F1F30"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 178.728,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 89.0134,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 111.442,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 133.871,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 156.299,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#696967"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#975928"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#66686B"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#8D5A30"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#CC3C5E"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#CC3C5E"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#CC3C5E"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#8F1F30"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#E0AA7E"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 66.5847,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 66.5847,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 112.143,
    y: 66.5847,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 89.7144,
    y: 66.5847,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    x: 67.2856,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "#92592D"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 44.8569,
    y: 44.1562,
    width: 22.4286,
    height: 22.4286,
    fill: "#92592D"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 22.4287,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "#935726"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#935C2D"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect179 || (_rect179 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect180 || (_rect180 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect181 || (_rect181 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect182 || (_rect182 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect183 || (_rect183 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect184 || (_rect184 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 156.299,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect185 || (_rect185 = /*#__PURE__*/React.createElement("rect", {
    x: 157,
    y: 178.728,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect186 || (_rect186 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 178.027,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect187 || (_rect187 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 200.455,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect188 || (_rect188 = /*#__PURE__*/React.createElement("rect", {
    x: 134.571,
    y: 223.585,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect189 || (_rect189 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect190 || (_rect190 = /*#__PURE__*/React.createElement("rect", {
    x: 201.857,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect191 || (_rect191 = /*#__PURE__*/React.createElement("rect", {
    x: 179.429,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect192 || (_rect192 = /*#__PURE__*/React.createElement("rect", {
    x: 224.286,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect193 || (_rect193 = /*#__PURE__*/React.createElement("rect", {
    x: 246.714,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#915B2D"
  })), _rect194 || (_rect194 = /*#__PURE__*/React.createElement("rect", {
    x: 269.143,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#636A70"
  })), _rect195 || (_rect195 = /*#__PURE__*/React.createElement("rect", {
    x: 291.571,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#CFC7C0"
  })), _rect196 || (_rect196 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect197 || (_rect197 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect198 || (_rect198 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect199 || (_rect199 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect200 || (_rect200 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect201 || (_rect201 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect202 || (_rect202 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect203 || (_rect203 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#8F1F30"
  })), _rect204 || (_rect204 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 200.455,
    width: 22.4286,
    height: 22.4286,
    fill: "#8F1F30"
  })), _rect205 || (_rect205 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 201.156,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect206 || (_rect206 = /*#__PURE__*/React.createElement("rect", {
    x: 403.714,
    y: 201.156,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect207 || (_rect207 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 201.156,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect208 || (_rect208 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 201.156,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect209 || (_rect209 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect210 || (_rect210 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect211 || (_rect211 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect212 || (_rect212 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect213 || (_rect213 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect214 || (_rect214 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect215 || (_rect215 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect216 || (_rect216 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect217 || (_rect217 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 223.585,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect218 || (_rect218 = /*#__PURE__*/React.createElement("rect", {
    x: 381.286,
    y: 222.884,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect219 || (_rect219 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "#4E381D"
  })), _rect220 || (_rect220 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 246.714,
    width: 22.4286,
    height: 22.4286,
    fill: "#4E381D"
  })), _rect221 || (_rect221 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#4E381D"
  })), _rect222 || (_rect222 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 269.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#4E381D"
  })), _rect223 || (_rect223 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 223.585,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect224 || (_rect224 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 246.013,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect225 || (_rect225 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 246.013,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect226 || (_rect226 = /*#__PURE__*/React.createElement("rect", {
    x: 314,
    y: 267.741,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect227 || (_rect227 = /*#__PURE__*/React.createElement("rect", {
    x: 336.429,
    y: 267.741,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect228 || (_rect228 = /*#__PURE__*/React.createElement("rect", {
    x: 358.857,
    y: 223.585,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9854C"
  })), _rect229 || (_rect229 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect230 || (_rect230 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#8D5A30"
  })), _rect231 || (_rect231 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect232 || (_rect232 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect233 || (_rect233 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect234 || (_rect234 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect235 || (_rect235 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect236 || (_rect236 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect237 || (_rect237 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect238 || (_rect238 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect239 || (_rect239 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect240 || (_rect240 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect241 || (_rect241 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect242 || (_rect242 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#66686B"
  })), _rect243 || (_rect243 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect244 || (_rect244 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect245 || (_rect245 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect246 || (_rect246 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#E2AB7C"
  })), _rect247 || (_rect247 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect248 || (_rect248 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#D9D9D9"
  })), _rect249 || (_rect249 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#D9D9D9"
  })), _rect250 || (_rect250 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect251 || (_rect251 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect252 || (_rect252 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "#D9D9D9"
  })), _rect253 || (_rect253 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "#E4AA78"
  })), _rect254 || (_rect254 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "#E4AA78"
  })), _rect255 || (_rect255 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect256 || (_rect256 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "#C9844C"
  })), _rect257 || (_rect257 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect258 || (_rect258 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 93.9197,
    width: 22.4286,
    height: 22.4286,
    fill: "#D9D9D9"
  })), _rect259 || (_rect259 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 116.348,
    width: 22.4286,
    height: 22.4286,
    fill: "#E4AA78"
  })), _rect260 || (_rect260 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 138.777,
    width: 22.4286,
    height: 22.4286,
    fill: "#E4AA78"
  })), _rect261 || (_rect261 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 161.205,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect262 || (_rect262 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 183.634,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect263 || (_rect263 = /*#__PURE__*/React.createElement("rect", {
    x: 695.286,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "#CBC9CD"
  })), _rect264 || (_rect264 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect265 || (_rect265 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect266 || (_rect266 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect267 || (_rect267 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect268 || (_rect268 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect269 || (_rect269 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect270 || (_rect270 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect271 || (_rect271 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 22.4285,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect272 || (_rect272 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect273 || (_rect273 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect274 || (_rect274 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect275 || (_rect275 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect276 || (_rect276 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 89.7144,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect277 || (_rect277 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect278 || (_rect278 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 112.143,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect279 || (_rect279 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect280 || (_rect280 = /*#__PURE__*/React.createElement("rect", {
    x: 695.286,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect281 || (_rect281 = /*#__PURE__*/React.createElement("rect", {
    x: 695.286,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect282 || (_rect282 = /*#__PURE__*/React.createElement("rect", {
    x: 717.714,
    y: 134.572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect283 || (_rect283 = /*#__PURE__*/React.createElement("rect", {
    x: 717.714,
    y: 157,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect284 || (_rect284 = /*#__PURE__*/React.createElement("rect", {
    x: 717.714,
    y: 179.428,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect285 || (_rect285 = /*#__PURE__*/React.createElement("rect", {
    x: 695.286,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect286 || (_rect286 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect287 || (_rect287 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect288 || (_rect288 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 201.857,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect289 || (_rect289 = /*#__PURE__*/React.createElement("rect", {
    x: 672.857,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect290 || (_rect290 = /*#__PURE__*/React.createElement("rect", {
    x: 650.429,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect291 || (_rect291 = /*#__PURE__*/React.createElement("rect", {
    x: 628,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect292 || (_rect292 = /*#__PURE__*/React.createElement("rect", {
    x: 605.571,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect293 || (_rect293 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect294 || (_rect294 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect295 || (_rect295 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect296 || (_rect296 = /*#__PURE__*/React.createElement("rect", {
    x: 515.857,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect297 || (_rect297 = /*#__PURE__*/React.createElement("rect", {
    x: 493.429,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect298 || (_rect298 = /*#__PURE__*/React.createElement("rect", {
    x: 471,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect299 || (_rect299 = /*#__PURE__*/React.createElement("rect", {
    x: 448.571,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect300 || (_rect300 = /*#__PURE__*/React.createElement("rect", {
    x: 426.143,
    y: 224.286,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect301 || (_rect301 = /*#__PURE__*/React.createElement("rect", {
    x: 583.143,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect302 || (_rect302 = /*#__PURE__*/React.createElement("rect", {
    x: 560.714,
    y: 44.8572,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })), _rect303 || (_rect303 = /*#__PURE__*/React.createElement("rect", {
    x: 538.286,
    y: 67.2856,
    width: 22.4286,
    height: 22.4286,
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixelArtDog);
export default __webpack_public_path__ + "static/media/pixel-art-dog.7ce186d1208c0f41fce86efb9a21ac12.svg";
export { ForwardRef as ReactComponent };